export const setGlobalStyles = (styles, type) => {
  const root = document.documentElement;

  if (!styles) {
    root.style.setProperty(`--${type}primaryColor`, '#009DD7');
    root.style.setProperty(`--${type}secondaryColor`, '#009DD7');
    root.style.setProperty(`--${type}logoFileName`, null);
    root.style.setProperty(`--${type}borderRadiusBody`, '6px');
    root.style.setProperty(`--${type}borderRadiusButton`, '6px');
    return;
  }
  const { primaryColor, secondaryColor, logoFileId, borderRadiusBody, borderRadiusButton } = styles;

  root.style.setProperty(`--${type}primaryColor`, primaryColor !== null ? primaryColor : '#009DD7');
  root.style.setProperty(`--${type}secondaryColor`, secondaryColor !== null ? secondaryColor : '#009DD7');
  root.style.setProperty(`--${type}logoFileName`, logoFileId);
  root.style.setProperty(`--${type}borderRadiusBody`, borderRadiusBody !== null ? `${borderRadiusBody}px` : '6px');
  root.style.setProperty(`--${type}borderRadiusButton`, borderRadiusButton !== null ? `${borderRadiusButton}px` : '6px');
};

export const DEFAULT_STYLES = [
  {
    type: 'form',
    styles: {
      primaryColor: '#009DD7',
      secondaryColor: '#009DD7',
      logoFileId: null,
      borderRadiusBody: '6',
      borderRadiusButton: '6',
    },
  },
  {
    type: 'calculator',
    styles: {
      primaryColor: '#009DD7',
      secondaryColor: '#009DD7',
      logoFileId: null,
      borderRadiusBody: '6',
      borderRadiusButton: '6',
    },
  },
];

export const sliderSetup = {
  min: 0,
  max: 100,
  step: 1,
  defaultValue: 2,
  handleStyle: {
    borderColor: '#009DD7',
    background: '#009DD7',
  },
  activeDotStyle: {
    borderColor: '#009DD7',
    background: '#009DD7',
    opacity: 1,
  },
  trackStyle: {
    background: '#009DD7',
    opacity: 1,
  },
};

export const sliderSetupButton = {
  min: 0,
  max: 25,
  step: 1,
  defaultValue: 2,
  handleStyle: {
    borderColor: '#009DD7',
    background: '#009DD7',
  },
  activeDotStyle: {
    borderColor: '#009DD7',
    background: '#009DD7',
    opacity: 1,
  },
  trackStyle: {
    background: '#009DD7',
    opacity: 1,
  },
};

export const hasNullStyles = (styles) => {
  return styles.some((style) => Object.values(style.styles).some((value) => value === null));
};
